export enum SalaryStatusCodes {
  OPEN = 1,
  AWAITING_APPROVAL,
  AWAITING_APPROVAL_OF_PAYROLL_ADMIN,
  AWAITING_APPROVAL_OF_HR,
  UNDER_PROCESS,
  READY_TO_COLLECT,
  ISSUED,
  REJECTED,
  CANCELLED,
}
